import { render } from "./DonutChart.vue?vue&type=template&id=4fd97772&scoped=true"
import script from "./DonutChart.vue?vue&type=script&lang=js"
export * from "./DonutChart.vue?vue&type=script&lang=js"

import "./DonutChart.vue?vue&type=style&index=0&id=4fd97772&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fd97772"]])

export default __exports__